module.exports = __webpack_public_path__ + "media/content-creator/mobile-fashion-2-d567a965.png";